import React from 'react';
import { useSelector } from 'react-redux';

import { isAuthenticated } from 'src/features/auth';

import './login.scss';
import { Redirect } from 'react-router-dom';

export const Login: React.FC = () => {
  const isAuth = useSelector(isAuthenticated);

  return isAuth ? <Redirect to="/navigation" /> : <Redirect to="/sso" />;
};
